module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    primary: '#748E5F',
                    blue: '#4ca1da',
                    lightgreen: '#F2F7ED',
                    darkprimary: '#556e41',
                    gray: '#9CA3AF',
                    lightgray: '#F5F5F5',
                    black: '#101926',
                    green: '#22C55E',
                    greenhover: '#6EBF2C',
                    darkgreen: '#12B24D',
                    orange: '#f59e0b',
                    darkorange: '#E09310',
                }
            },
        },
        fontFamily: {
            poppins: ['Poppins', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/galaxy/common/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
